export const RemoteRenderingActionEnum = {
  // region Common
  GetBrightnessAndContrast: "wslink.get.brightness.and.contrast",
  SetBrightnessAndContrast: "wslink.set.brightness.and.contrast",
  ResetView: "wslink.reset.view",
  // endregion Common

  // region Image & Session Management
  LoadImage: "wslink.load.image",
  EndSession: "wslink.end.session",
  InitSession: "wslink.init.session",
  SetZoomSensitivity: "wslink.set.zoom.sensitivity",
  ChangeSliceLevel: "wslink.change.slicelevel",
  MouseWheelInteraction: "viewport.mouse.wheel",
  AssociateClientSession: "wslink.associate.client.session",
  // endregion Image & Session Management

  // region Spinesim visualization
  LoadSpinesimVisualizationView: "wslink.load.spinesimvisualizationview",

  // region Spinesim views stage and Surgery Operations
  LoadSpinesimViewStage: "wslink.load.spinesimviewstage",
  StartSurgery: "wslink.start.surgery",
  StartDecompensation: "wslink.start.decompensation",
  FocusImageOnRegion: "wslink.focus.image.on.region",
  FocusOnEndplate: "wslink.focus.on.endplate",
  // endregion Spinesim views stage and Surgery Operations

  // region Custom Measurements & Tool Visibility
  SetToolVisibility: "wslink.set.toolvisibility",
  SetToolOpacity: "wslink.set.toolopacity",
  SetMeasurementVisibility: "wslink.set.measurementvisibility",
  SetCustomMeasurementVisibility: "wslink.set.custommeasurementvisibility",
  AddCustomMeasurement: "wslink.add.custommeasurement",
  RemoveCustomMeasurement: "wslink.remove.custommeasurement",
  UpdateMeasurement: "wslink.update.measurement",
  GetVisibleMeasurements: "wslink.get.visible.measurements",
  GetMeasurements: "wslink.get.measurements",
  // endregion Custom Measurements & Tool Visibility

  // region Radio Density
  GetRadioDensityStatistics: "wslink.get.radiodensity.statistics",
  SetAxialRadiodensityVertebra: "wslink.set.axial.radiodensity.vertebra",
  SetRadiodensityProjectionFilter: "wslink.set.radiodensity.projection.filter",
  UpdateRadiodensityCylinders: "wslink.update.radiodensity.cylinders",
  RadioDensityVertebraSelected: "wslink.radiodensity.vertebra.selected",
  // endregion Radio Density

  // region Vertebra Selection
  StartVertebraSelection: "wslink.start.vertebralselection",
  VertebraSelection: "wslink.select.vertebralselection",
  StopVertebraSelection: "wslink.stop.vertebralselection",
  // endregion Vertebra Selection

  // region Data Fusion
  ShowCtFusionView: "wslink.show.ctfusionview",
  HideCtFusionView: "wslink.hide.ctfusionview",
  ChangeCtFusionSlice: "wslink.change.ctfusionslice",
  GetFusionVisibilityState: "wslink.get.fusion.visibility.state",
  // endregion Data Fusion

  // region Global Alignment
  GetInitialGlobalAlignment: "wslink.get.initial.globalalignment",
  UpdateGlobalAlignment: "wslink.update.globalalignment",
  HideGlobalAlignmentTool: "wslink.hide.globalalignmenttool",
  // endregion Global Alignment

  // region Segmental Transformation Tools
  ShowSegmentalTransformationTool: "wslink.show.segmentaltransformationtool",
  HideSegmentalTransformationTool: "wslink.hide.segmentaltransformationtool",
  SegmentalTransfromationToolManualChange:
    "wslink.update.segmentaltransformationtool.manual.value",
  GetSegmentalTransformationAttributes:
    "wslink.get.segmentaltransformation.attributes",
  TranslateSegmentalTransformationTool:
    "wslink.translate.segmentaltransformationtool",
  RotateSegmentalTransformationTool:
    "wslink.rotate.segmentaltransformationtool",
  // endregion Segmental Transformation Tools

  // region Osteotomy Tools
  ShowOsteotomyTool: "wslink.show.osteotomytool",
  HideOsteotomyTool: "wslink.hide.osteotomytool",
  UpdateOsteotomyToolValue: "wslink.update.osteotomytool.value",
  OsteotomyToolManualChange: "wslink.update.osteotomytool.manual.value",
  GetOsteotomySupportValues: "wslink.get.osteotomy.support.values",
  // endregion Osteotomy Tools

  // region Cage Tools
  ShowCageTool: "wslink.show.cagetool",
  RemoveCagePreview: "wslink.remove.cage.preview",
  GetCageAttributes: "wslink.get.cage.attributes",
  RotateCageTool: "wslink.rotate.cagetool",
  SetHeightCageTool: "wslink.set.height.cagetool",
  SetWidthCageTool: "wslink.set.width.cagetool",
  SetPositionCageTool: "wslink.set.position.cagetool",
  CageToolManualChange: "wslink.update.cagetool.manual.value",
  RemoveCageHardware: "wslink.remove.cage.hardware",
  // endregion Cage Tools

  // region Rods Tools
  ShowRodTool: "wslink.show.rodtool",
  RemoveRodPreview: "wslink.remove.rod.preview",
  GetRodAttributes: "wslink.get.rod.attributes",
  RemoveRodHardware: "wslink.remove.rod.hardware",
  HideRodHardware: "wslink.hide.rod.hardware",
  ShowRodHardware: "wslink.show.rod.hardware",
  //#endregion

  // region Annotations
  GetUpdatedAnnotations: "wslink.get.updated.annotations",
  // endregion Annotations

  // region Vertebra Management
  GetAvailableVertebrae: "wslink.get.available.vertebrae",
  GetDeletableVertebrae: "wslink.get.deletable.vertebrae",
  AddVertebra: "wslink.add.vertebra",
  RemoveVertebra: "wslink.remove.vertebra",
  // endregion Vertebra Management

  // region Landmark Management
  GetAvailableLandmarks: "wslink.get.available.landmarks",
  GetDeletableLandmarks: "wslink.get.deletable.landmarks",
  AddLandmark: "wslink.add.landmark",
  RemoveLandmark: "wslink.remove.landmark",
  // endregion Landmark Management

  // region Validation
  SetValidationLock: "wslink.set.validation.lock",
  UndoValidation: "wslink.undo.validation",
  RedoValidation: "wslink.redo.validation",
  ResetValidation: "wslink.reset.validation",
  GetValidationHistoryState: "wslink.get.validation.history.state",
  SetValidationToolComponentsVisibility:
    "wslink.set.validation.tool.components.visibility",
  SetDrrPointId: "wslink.drr.validation.set.point.id",
  RemoveDrrPoint: "wslink.drr.validation.remove.point",
  GetDrrPointsState: "wslink.drr.validation.points.state",
  DrrValidationPointAdded: "wslink.drr.validation.point.added",
  GetFunctionalEndplateOptions: "wslink.get.functional.endplate.options",
  // endregion Validation

  // region Additional & Interaction
  StartMouseTracking: "wslink.start.mouse.tracking",
  EndMouseTracking: "wslink.end.mouse.tracking",
  MousePositionUpdate: "wslink.mouse.position",
  MouseInteraction: "viewport.mouse.interaction",
  UpdateViews: "wslink.update.views",
  ManualSegmentalTransformationToolUpdate:
    "wslink.manual.segmental.transformation.tool.update",
  Toggle_loading: "wslink.toggle.loading",
  // endregion Additional & Interaction
};
